export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const APP_SIGNUP_REQUEST = 'APP_SIGNUP_REQUEST';
export const APP_SIGNUP_SUCCESS = 'APP_SIGNUP_SUCCESS';
export const APP_SIGNUP_FAILURE = 'APP_SIGNUP_FAILURE';

export const APP_GET_USER_REQUEST = 'APP_GET_USER_REQUEST';
export const APP_GET_USER_SUCCESS = 'APP_GET_USER_SUCCESS';
export const APP_GET_USER_FAILURE = 'APP_GET_USER_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const RECOVER_PASS_REQUEST = 'RECOVER_PASS_REQUEST';
export const RECOVER_PASS_SUCCESS = 'RECOVER_PASS_SUCCESS';
export const RECOVER_PASS_FAILURE = 'RECOVER_PASS_FAILURE';

export const RECOVER_PASS_VERIFY_LINK_REQUEST = 'RECOVER_PASS_VERIFY_LINK_REQUEST';
export const RECOVER_PASS_VERIFY_LINK_SUCCESS = 'RECOVER_PASS_VERIFY_LINK_SUCCESS';
export const RECOVER_PASS_VERIFY_LINK_FAILURE = 'RECOVER_PASS_VERIFY_LINK_FAILURE';

export const CHANGE_PASS_REQUEST = 'CHANGE_PASS_REQUEST';
export const CHANGE_PASS_SUCCESS = 'CHANGE_PASS_SUCCESS';
export const CHANGE_PASS_FAILURE = 'CHANGE_PASS_FAILURE';

export const CHANGE_LIVELI_PASS_REQUEST = 'CHANGE_LIVELI_PASS_REQUEST';
export const CHANGE_LIVELI_PASS_SUCCESS = 'CHANGE_LIVELI_PASS_SUCCESS';
export const CHANGE_LIVELI_PASS_FAILURE = 'CHANGE_LIVELI_PASS_FAILURE';

export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const CLEAR_USER_STATE = 'CLEAR_USER_STATE';
export const CLEAR_LOADING_USER = 'CLEAR_LOADING_USER';

export const SOCIAL_LOGIN_REQUEST = 'SOCIAL_LOGIN_REQUEST';
export const SOCIAL_LOGIN_SUCCESS = 'SOCIAL_LOGIN_SUCCESS';
export const SOCIAL_LOGIN_FAILURE = 'SOCIAL_LOGIN_FAILURE';

export const PUT_BADGE_COLOR_REQUEST = 'PUT_BADGE_COLOR_REQUEST';
export const PUT_BADGE_COLOR_SUCCESS = 'PUT_BADGE_COLOR_SUCCESS';
export const PUT_BADGE_COLOR_FAILURE = 'PUT_BADGE_COLOR_FAILURE';

export const GET_BADGE_COLOR_REQUEST = 'GET_BADGE_COLOR_REQUEST';
export const GET_BADGE_COLOR_SUCCESS = 'GET_BADGE_COLOR_SUCCESS';
export const GET_BADGE_COLOR_FAILURE = 'GET_BADGE_COLOR_FAILURE';

export const INITIAL_NOTIFICATIONS = 'INITIAL_NOTIFICATIONS'
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS'

export const GET_SETTINGS_REQUEST = 'GET_SETTINGS_REQUEST';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_FAILURE = 'GET_SETTINGS_FAILURE';

export const SEND_WELCOME_EMAIL_BEGIN = 'SEND_WELCOME_EMAIL_BEGIN';
export const SEND_WELCOME_EMAIL_SUCCESS = 'SEND_WELCOME_EMAIL_SUCCESS';
export const SEND_WELCOME_EMAIL_FAILURE = 'SEND_WELCOME_EMAIL_FAILURE';

export const SET_CALENDAR_DEFAULT_VIEW = "SET_CALENDAR_DEFAULT_VIEW";

export const SET_CALENDAR_SETTINGS = "SET_CALENDAR_SETTINGS";

export const SET_CALENDAR_CHANGES = "SET_CALENDAR_CHANGES";

export const SET_STEP_TUTORIAL = "SET_STEP_TUTORIAL";

export const SHOW_TUTORIAL = "SHOW_TUTORIAL";
